export function _setNewStatus(device, reportStatus) {
  var updateThisItem = device;

  if (device.deviceType === 'Curtain') {
    reportStatus.forEach(state => {
      if (state.code === 'percent_state') {
        updateThisItem.deviceState.percentState = state.value;
      } else if (state.code === 'control') {
        updateThisItem.deviceState.control = state.value;
      } else if (state.code === 'percent_control') {
        updateThisItem.deviceState.percentControl = state.value;
      }
    });
  } else if (device.deviceType === 'IrAirconditioner') {
    reportStatus.forEach(state => {
      if (state.code === 'wind') {
        updateThisItem.deviceState.fanSpeed = Number(state.value);
      } else if (state.code === 'temp') {
        updateThisItem.deviceState.temperature = Number(state.value);
      } else if (state.code === 'switch_power') {
        updateThisItem.deviceState.power = state.value;
      } else {
        updateThisItem.deviceState[state.code] = state.value;
      }
    });
  } else if (device.deviceType.indexOf('Switch') === 0) {
    reportStatus.forEach(state => {
      let switchKey = state.code.replace('switch_', 'power');

      updateThisItem.deviceState[switchKey] = state.value;
    });
  } else if (
    device.deviceType.indexOf('Light') === 0 ||
    device.deviceType.indexOf('Led') === 0
  ) {
    reportStatus.forEach(state => {
      if (state.code === 'bright_value') {
        updateThisItem.deviceState.brightness = Math.round(
          ((state.value - 25) * 100) / 230
        );
      } else if (state.code === 'colour_data') {
        let colorData = JSON.parse(state.value);
        updateThisItem.deviceState.hsvColor.hue = colorData.h;
        updateThisItem.deviceState.hsvColor.saturation = Math.round(
          ((colorData.s - 25) * 100) / 230
        );
        updateThisItem.deviceState.hsvColor.brightness = Math.round(
          ((colorData.v - 25) * 100) / 230
        );
      } else if (state.code === 'work_mode') {
        updateThisItem.deviceState.lightMode = state.value.toUpperCase();
      } else if (state.code === 'temp_value') {
        updateThisItem.deviceState.temperature = Math.round(
          (state.value * 100) / 230
        );
      } else if (state.code === 'switch_led') {
        updateThisItem.deviceState.power = state.value;
      } else {
        updateThisItem.deviceState[state.code] = state.value;
      }
    });
  } else if (
    device.deviceType === 'SmartPlug' ||
    device.deviceType === 'BruntPlug'
  ) {
    reportStatus.forEach(state => {
      if (state.code === 'switch_1') {
        updateThisItem.deviceState.power = state.value;
      } else {
        let plugKey = state.code.split('_')[1];
        plugKey = 'cur' + capitalize(plugKey);
        updateThisItem.deviceState[plugKey] = state.value;
      }
    });
  } else if (device.deviceType === 'SensorTh') {
    reportStatus.forEach(state => {
      if (state.code === 'battery') {
        updateThisItem.deviceState.battery = state.value;
      } else {
        let sensorThKey = state.code.split('_')[1];
        updateThisItem.deviceState[sensorThKey] = Math.floor(
          Number(state.value) / 100
        );
      }
    });
  } else if (device.deviceType === 'SensorDo') {
    reportStatus.forEach(state => {
      if (state.code === 'prm_switch') {
        updateThisItem.deviceState.state = state.value ? 'OPEN' : 'CLOSED';
      } else if (state.code === 'switch') {
        updateThisItem.deviceState.state = state.value ? 'OPEN' : 'CLOSED';
      }
    });
  } else if (device.deviceType === 'SensorMo') {
    reportStatus.forEach(state => {
      if (state.code === 'pir') {
        updateThisItem.deviceState['t'] = state.t;
      }
    });
  } else if (device.deviceType === 'Airpurifier') {
    reportStatus.forEach(state => {
      if (state.code === 'switch') {
        updateThisItem.deviceState.power = state.value;
      } else {
        updateThisItem.deviceState[state.code] = state.value;
      }
    });
  } else if (device.deviceType === 'RelayController') {
    reportStatus.forEach(state => {
      if (state.code === 'switch_1') {
        updateThisItem.deviceState.power1 = state.value;
      }
    });
  } else if (device.deviceType === 'AudibleAlarm') {
    reportStatus.forEach(state => {
      if (state.code === 'alarm_switch') {
        updateThisItem.deviceState['t'] = state.t;
        updateThisItem.deviceState.alarmSwitch = state.value;
      }
      if (state.code === 'alarm_state') {
        updateThisItem.deviceState['t'] = state.t;
      }
    });
  } else if (device.deviceType === 'SensorTh2') {
    reportStatus.forEach(state => {
      if (state.code === 'battery') {
        updateThisItem.deviceState.battery = state.value;
      } else {
        let sensorThKey = state.code.split('_')[1];
        updateThisItem.deviceState[sensorThKey] = Math.floor(
          Number(state.value) / 100
        );
      }
    });
  } else if (device.deviceType === 'SensorRadar') {
    reportStatus.forEach(state => {
      if (state.code === 'pir') {
        updateThisItem.deviceState['t'] = state.t;
      }
    });
  } else if (device.deviceType === 'SmartButton') {
    reportStatus.forEach(state => {
      if (state.code === 'pir') {
        updateThisItem.deviceState['t'] = state.t;
      }
    });
  } else if (device.deviceType === 'Blind2' || device.deviceType === 'Blind') {
    reportStatus.forEach(state => {
      if (state.code === 'percent_state') {
        updateThisItem.deviceState.percentState = state.value;
      } else if (state.code === 'control') {
        updateThisItem.deviceState.control = state.value;
      } else if (state.code === 'percent_control') {
        updateThisItem.deviceState.percentControl = state.value;
      }
    });
  } else if (
    device.deviceType === 'PowerStrip' ||
    device.deviceType === 'PowerStrip2'
  ) {
    reportStatus.forEach(state => {
      const powers = ['switch_1', 'switch_2', 'switch_3'];
      if (powers.includes(state.code)) {
        const powerStripKey = state.code.replace('switch_', 'power');
        updateThisItem.deviceState[powerStripKey] = state.value;
      } else if (state.code === 'switch_usb1') {
        updateThisItem.deviceState.power4 = state.value;
      } else if (state.code === 'switch') {
        if (state.value) {
          updateThisItem.deviceState.power1 = state.value;
          updateThisItem.deviceState.power2 = state.value;
          updateThisItem.deviceState.power3 = state.value;
          updateThisItem.deviceState.power4 = state.value;
          updateThisItem.deviceState.power5 = state.value;
        } else {
          updateThisItem.deviceState.power5 = state.value;
        }
      }
    });
  } else if (device.deviceType === 'SensorRefTh2') {
    reportStatus.forEach(state => {
      if (state.code === 'va_temperature') {
        updateThisItem.deviceState.temperature = parseToDecimalPoint(
          state.value
        );
      } else if (state.code === 'va_humidity') {
        updateThisItem.deviceState.humidity = parseToDecimal(state.value);
      } else if (state.code === 'temp_unit_convert') {
        updateThisItem.deviceState.tempUnitConvert = state.value;
      } else if (state.code === 'maxtemp_set') {
        updateThisItem.deviceState.maxTempSet = parseToDecimalPoint(
          state.value
        );
      } else if (state.code === 'minitemp_set') {
        updateThisItem.deviceState.miniTempSet = parseToDecimalPoint(
          state.value
        );
      } else if (state.code === 'maxhum_set') {
        updateThisItem.deviceState.maxHumSet = state.value;
      } else if (state.code === 'minihum_set') {
        updateThisItem.deviceState.miniHumSet = state.value;
      } else if (state.code === 'temp_alarm') {
        updateThisItem.deviceState.temp_alarm = state.value;
      } else if (state.code === 'hum_alarm') {
        updateThisItem.deviceState.hum_alarm = state.value;
      }
    });
  } else if (device.deviceType === 'SensorGas2') {
    reportStatus.forEach(state => {
      updateThisItem.deviceState.alarm = state.value === '1';
    });
  } else if (device.deviceType === 'SensorWater2') {
    reportStatus.forEach(state => {
      updateThisItem.deviceState.alarm = state.value === '1';
    });
  } else if (device.deviceType === 'SensorWater3') {
    reportStatus.forEach(state => {
      updateThisItem.deviceState.alarm = state.value === '1';
    });
  } else if (device.deviceType === 'SensorSmoke3') {
    reportStatus.forEach(state => {
      updateThisItem.deviceState.alarm = state.value === 'alarm';
    });
  } else if (device.deviceType === 'SensorSmoke4') {
    reportStatus.forEach(state => {
      updateThisItem.deviceState.alarm = state.value === 'alarm';
    });
  } else if (
    device.deviceType === 'SmartDoorLock' ||
    device.deviceType === 'ZigbeeDoorlock'
  ) {
    reportStatus.forEach(state => {
      if (state.code === 'door_opened') {
        updateThisItem.deviceState.doorOpened = state.value;
      }
    });
  }
  return updateThisItem;
}

function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function parseToDecimal(value) {
  // 소수점 1자리 처리후, 내림 처리
  let index = 2;
  if (value < 100) index = 1;
  const parsedDecimalPoint =
    value.toString().substring(0, index) +
    '.' +
    value.toString().substring(index);
  return Math.round(parseFloat(parsedDecimalPoint));
}

function parseToDecimalPoint(value) {
  //  소수점 1자리 처리
  let index = 2;

  if (value < 0) {
    if (value > -10) {
      index = 1;
    } else if (value > -100) {
      index = 2;
    } else {
      index = 3;
    }
  } else {
    if (value > 1000) {
      index = 3;
    } else if (value < 100) {
      index = 1;
    }
  }

  const parsedDecimalPoint =
    value.toString().substring(0, index) +
    '.' +
    value.toString().substring(index);
  return parseFloat(parsedDecimalPoint);
}
